import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_pic_set = _resolveComponent("pic-set");
    const _component_q_avatar = _resolveComponent("q-avatar");
    return (_openBlock(), _createElementBlock("div", {
        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('click')))
    }, [
        _createVNode(_component_q_avatar, {
            size: _ctx.size,
            style: _normalizeStyle({
                'width': _ctx.size,
                'height': _ctx.size
            }),
            class: _normalizeClass({
                ..._ctx.avatarClass,
                'round': true
            })
        }, {
            default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "badge"),
                _createVNode(_component_pic_set, {
                    "pic-class": {
                        ..._ctx.picClass,
                        'full-width round': true
                    },
                    "webp-src-set": _ctx.srcSets.webp,
                    "original-src": _ctx.picImg,
                    "original-src-set": _ctx.srcSets.original,
                    sizes: _ctx.componentSize || _ctx.size,
                    alt: _ctx.defaultAlt,
                    alternative: _ctx.alternate,
                    "alternative-src-set": _ctx.alternativeSrcSet,
                    "alternative-webp-src-set": _ctx.alternativeWebpSrcSet,
                    "allow-other-formats": _ctx.allowOtherFormats,
                    ratio: 1,
                    "show-load": _ctx.showLoad
                }, null, 8, ["pic-class", "webp-src-set", "original-src", "original-src-set", "sizes", "alt", "alternative", "alternative-src-set", "alternative-webp-src-set", "allow-other-formats", "show-load"])
            ]),
            _: 3
        }, 8, ["size", "style", "class"])
    ]));
}
